import axios from "axios"
import { API_TIMEOUT_MS } from "constants/apiTimeout"

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1/"

export const fetchPortalTenantResolve = async host => {
  const language =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("I18N_LANGUAGE")
      : null

  const response = await axios.get(`${API_URL}public/portal/resolve`, {
    params: { host },
    timeout: API_TIMEOUT_MS,
    headers: {
      "Accept-Language": language === "sa" ? "ar" : "en",
    },
  })

  const payload = response?.data
  if (payload?.status && payload?.data) {
    return payload.data
  }

  throw new Error(payload?.msg || payload?.message || "Unable to resolve portal tenant")
}
